import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('', 'merge');

tbl.add(new Xtc('merge', 'Merge Field').renderSlot('merge'))
tbl.add(new Xtc('value', 'Value').renderSlot('value'))

export default tbl;

